"use client";

import { Instagram, Youtube, Activity, BookOpen } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
export default function Footer() {
  const shopLinks = [{
    label: "All Flavors",
    to: "/ShopPage"
  }, {
    label: "Seasonal",
    to: "#"
  }, {
    label: "Classics",
    to: "#"
  }, {
    label: "Vegan",
    to: "#"
  }, {
    label: "Bundles",
    to: "/GiftingBundlesPage"
  }];
  const trailmadeLinks = [{
    label: "Our Story",
    to: "/TheArtisanalProcessPage"
  }, {
    label: "Ingredients",
    to: "#"
  }, {
    label: "Sustainability",
    to: "#"
  }, {
    label: "Journal",
    to: "#"
  }, {
    label: "Careers",
    to: "#"
  }];
  const supportLinks = [{
    label: "Contact",
    to: "#"
  }, {
    label: "FAQ",
    to: "#"
  }, {
    label: "Shipping",
    to: "#"
  }, {
    label: "Returns",
    to: "#"
  }, {
    label: "Wholesale",
    to: "#"
  }];
  const socialLinks = [{
    Icon: Instagram,
    label: "Instagram",
    to: "#"
  }, {
    Icon: Youtube,
    label: "YouTube",
    to: "#"
  }, {
    Icon: Activity,
    label: "Strava",
    to: "#"
  }, {
    Icon: BookOpen,
    label: "Substack",
    to: "#"
  }];
  return <section data-section-id="14795" id="the-final-note" className="bg-background text-foreground border-t border-border py-24 md:py-32">
      <div className="max-w-[1440px] mx-auto px-5 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-8">
          {}
          <div className="sm:col-span-2 lg:col-span-5 flex flex-col">
            <Link to="/" className="inline-block mb-8">
              <WvcLogo className="h-8 w-auto" />
            </Link>
            <p className="font-default text-foreground/75 text-base leading-[1.65] max-w-sm mb-8">
              Artisanal ice cream crafted with intention. Small batches, premium ingredients, and a commitment to the perfect scoop.
            </p>
            <div className="flex items-center gap-5">
              {socialLinks.map((social, i) => {
              const IconComponent = social.Icon;
              return <Link key={social.label} to={social.to} aria-label={social.label} data-index={i} className="text-foreground/60 hover:text-primary transition-colors duration-200">
                    <IconComponent className="h-5 w-5" strokeWidth={1.5} />
                  </Link>;
            })}
            </div>
          </div>

          {}
          <div className="lg:col-span-2">
            <h4 className="font-default text-xs font-medium uppercase tracking-[0.16em] text-foreground/60 mb-6">
              Shop
            </h4>
            <ul className="flex flex-col gap-3">
              {shopLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.to} className="footer-link font-default text-sm text-foreground hover:text-primary relative inline-block transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="lg:col-span-2">
            <h4 className="font-default text-xs font-medium uppercase tracking-[0.16em] text-foreground/60 mb-6">
              Company
            </h4>
            <ul className="flex flex-col gap-3">
              {trailmadeLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.to} className="footer-link font-default text-sm text-foreground hover:text-primary relative inline-block transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="lg:col-span-3">
            <h4 className="font-default text-xs font-medium uppercase tracking-[0.16em] text-foreground/60 mb-6">
              Support
            </h4>
            <ul className="flex flex-col gap-3">
              {supportLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.to} className="footer-link font-default text-sm text-foreground hover:text-primary relative inline-block transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        {}
        <div className="mt-20 pt-8 border-t border-border flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="font-default text-xs tracking-[0.01em] text-foreground/50">
            {"\u00A9 2025 SCOOP Creamery"}
          </p>
          <p className="font-mono text-xs tracking-[0.04em] text-foreground/50">
            Churned with love in the city
          </p>
        </div>
      </div>

      <style>{`
        .footer-link::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: -2px;
          width: 0;
          height: 1px;
          background-color: var(--primary);
          transition: width 220ms ease-out;
        }
        .footer-link:hover::after {
          width: 100%;
        }
      `}</style>
    </section>;
}